
import { Link } from "gatsby";
//import PropTypes from "prop-types"
import React, { useState } from "react";
import {
  Collapse, Container,
  Nav, Navbar,
  NavbarToggler
} from 'reactstrap';
import logo from "./../images/GLOBAL-LINK-LOGISTICS-logo.png";
import NavList from './navItem';
//import { useSiteInfo } from "./particles/hooks/useSiteInfo";
import { useSiteMenuData } from "./particles/hooks/useSiteMenuData";


const Header = (props) => {
  
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const menuData = useSiteMenuData()
  const headerData = menuData.nodes.find(menu => menu.slug === "main-menu")
  const headerDataMenuRight = menuData.nodes.find(menu => menu.slug === "menu-right")

  const flatListToHierarchical = (data = [], {idKey='id',parentKey='parentId',childrenKey='children'} = {}) => {
    const tree = [];
    const childrenOf = {};
    data.forEach((item) => {
        const newItem = {...item};
        const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
        childrenOf[id] = childrenOf[id] || [];
        newItem[childrenKey] = childrenOf[id];
        parentId
            ? (
                childrenOf[parentId] = childrenOf[parentId] || []
            ).push(newItem)
            : tree.push(newItem);
    });
    return tree;
  };
  const primaryMenu = flatListToHierarchical( headerData.menuItems.nodes );
  const menuRight = flatListToHierarchical( headerDataMenuRight.menuItems.nodes );

  //console.log(hierarchicalList);
  return (
      <Navbar light expand="md">
        <Container>
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="" />
        </Link> 
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar className="justify-content-center order-2">
          <Nav className="m-auto" navbar>
              {primaryMenu.map(
                (item, index) =>
                  (
                    <NavList item={item} key={index} />
                  )
              )}
          </Nav>
          <Nav className="ml-auto">
              {menuRight.map(
                (item, index) =>
                  (
                    <NavList item={item} key={index} />
                  )
              )}
          </Nav>
        </Collapse>
        </Container>
      </Navbar>
  );
}


/*const MenuItem = ({ label, url }) => {
  return useRelative(url, label);
}*/


/*Header.propTypes = {
  Header: PropTypes.node.isRequired,
}*/

export default Header;